import useSessionTimeout from 'hooks/useSessionTimeout'

export default function SessionTimeout() {
  const envLimit = Number(process.env.REACT_APP_SESSION_TIMEOUT_MS) || 3600000
  useSessionTimeout(envLimit)
  return null
}
